import React from 'react';
import '../styles/styles.css';

export const NoMatch = () => (
  <section className="d-body">
  <div className="body-wrapper">
    <h2>No Match</h2>
  </div>
  </section>
)